<script setup lang="ts">
import type { PropType } from 'vue';
import { BadgeCheckIcon } from '@heroicons/vue/solid';
import { getUrlForCollection } from '~/utilities/url-slugs';
import { avatarGradientStyles } from '~/utilities/avatar-gradient';

const props = defineProps({
  collection: { type: Object as PropType<any>, required: true },
  namedClasses: { type: String as PropType<string>, default: 'font-bold text-neutral-700 dark:text-neutral-200' },
  unnamedClasses: {
    type: String as PropType<string>,
    default: 'font-semibold tracking-tight font-mono text-neutral-900 dark:text-neutral-50',
  },
  avatarDimension: { type: String as PropType<string>, default: '1.75rem' },
});
const { collection, namedClasses, unnamedClasses, avatarDimension } = toRefs(props);
</script>
<template>
  <NuxtLink
    :to="getUrlForCollection(collection)"
    :class="['flex items-center gap-1 text-sm', collection.name ? namedClasses : unnamedClasses]"
  >
    <div
      :class="[`inline overflow-hidden rounded-md`, !collection.thumbnail_uri ? 'bg-gradient-to-bl' : '']"
      :style="{
        ...avatarGradientStyles(collection.id),
        height: avatarDimension,
        width: avatarDimension,
        flexShrink: 0,
      }"
    >
      <img
        v-if="collection.thumbnail_uri"
        class="h-full w-full object-cover object-center"
        :src="collection.thumbnail_uri"
      />
    </div>
    {{ collection.name || collection.id.substring(0, 12) }}
    <BadgeCheckIcon v-if="collection.creator?.verification_state === 1" class="h-5 w-5 text-emerald-600" />
  </NuxtLink>
</template>
